import { Button, useDisclosure } from "@chakra-ui/react";
import { RiAddCircleLine } from "react-icons/ri";
import { AddRelationshipDialog } from "../Dialogs/AddRelationshipDialog";

interface AddRelationshipButtonProps {
  id: string;
  personType: "applicant" | "guardian";
}

export const AddRelationshipButton = ({
  id,
  personType,
}: AddRelationshipButtonProps) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  return (
    <>
      <Button
        aria-label="Add relationship"
        leftIcon={<RiAddCircleLine />}
        variant="outline"
        onClick={onOpen}
        colorScheme="gray"
      >
        Add relationship
      </Button>
      <AddRelationshipDialog
        id={id}
        isOpen={isOpen}
        personType={personType}
        onCancel={onClose}
        onAddRelationshipSuccess={onClose}
      />
    </>
  );
};
